(() => {
  if (customElements.get('nordsign-turnstile-check')) return;
  class NordsignTurnstileCheck extends HTMLElement {
    connectedCallback() {
      // This is a preview convenience gate, not authentication or server protection.
      if (this.initialized || window.Shopify?.theme?.role !== 'unpublished' ||
          new URLSearchParams(window.location.search).get('nordsign_upload_test') !== '1' ||
          window.location.hostname !== 'international-nordsign.myshopify.com' || !this.dataset.siteKey) return;
      this.initialized = true;
      this.startButton = this.querySelector('[data-turnstile-start]');
      this.copyButton = this.querySelector('[data-turnstile-copy]');
      this.jsonButton = this.querySelector('[data-turnstile-json]');
      this.output = this.querySelector('[data-turnstile-output]');
      this.status = this.querySelector('[data-turnstile-status]');
      this.startButton.addEventListener('click', () => this.start());
      this.copyButton.addEventListener('click', () => this.copy(false));
      this.jsonButton.addEventListener('click', () => this.copy(true));
      this.hidden = false;
    }

    clear(message = '') {
      clearTimeout(this.expiryTimer);
      this.token = '';
      this.payload = null;
      this.output.value = '';
      this.output.hidden = true;
      this.copyButton.disabled = true;
      this.jsonButton.disabled = true;
      this.status.textContent = message;
    }

    async start() {
      if (this.startButton.disabled) return;
      this.clear('Loading verification...');
      this.startButton.disabled = true;
      try {
        this.api = await window.NordsignTurnstile.load();
        if (!this.isConnected) return;
        if (this.widgetId !== undefined) this.api.remove(this.widgetId);
        this.widgetId = undefined;
        this.widgetId = this.api.render(this.querySelector('[data-turnstile-widget]'), {
          sitekey: this.dataset.siteKey,
          action: 'prepare_upload',
          theme: 'light',
          size: 'compact',
          'response-field': false,
          retry: 'never',
          'refresh-expired': 'manual',
          'refresh-timeout': 'manual',
          callback: token => this.receiveToken(token),
          'expired-callback': () => this.clear('Token expired.'),
          'timeout-callback': () => this.clear('Verification timed out.'),
          'unsupported-callback': () => this.clear('Verification is unavailable in this browser.'),
          'error-callback': () => this.clear('Verification unavailable. Check the site key and allowed hostname in Cloudflare.')
        });
        this.startButton.textContent = 'New token';
      } catch {
        if (this.isConnected) this.clear('Verification unavailable. Please try again.');
      } finally {
        this.startButton.disabled = false;
      }
    }

    receiveToken(token) {
      if (!this.isConnected) return;
      this.clear();
      if (typeof token !== 'string' || !token || token.length > 2048) {
        this.clear('Verification did not return a valid token.');
        return;
      }
      this.token = token;
      this.expiresAt = Date.now() + 270000;
      this.payload = {
        version: 1,
        action: 'prepare_upload',
        requestId: crypto.randomUUID(),
        file: { name: 'TEST-nordsign-upload.pdf', size: 1024, contentType: 'application/pdf' },
        botToken: token
      };
      this.output.value = JSON.stringify(this.payload, null, 2);
      this.output.hidden = false;
      this.copyButton.disabled = false;
      this.jsonButton.disabled = false;
      this.status.textContent = 'Token ready. Server verification pending.';
      this.expiryTimer = setTimeout(() => this.clear('Token expired.'), 270000);
    }

    async copy(json) {
      if (!this.token || Date.now() >= this.expiresAt) { this.clear('Token expired.'); return; }
      try {
        await navigator.clipboard.writeText(json ? this.output.value : this.token);
        this.status.textContent = json ? 'Test JSON copied.' : 'Token copied.';
      } catch {
        this.output.focus();
        this.output.select();
        this.status.textContent = 'Clipboard unavailable. Test JSON selected.';
      }
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.clear();
      if (this.widgetId !== undefined) this.api?.remove(this.widgetId);
      this.widgetId = undefined;
    }
  }
  customElements.define('nordsign-turnstile-check', NordsignTurnstileCheck);
})();
